import {Status} from '../../helpers/mergeability-status'
import {MergeAction} from '../../types'
import {useSidebarMergeData} from './use-sidebar-merge-data'
import {SidebarQueuedState} from './SidebarQueuedState'
import {SidebarDisableAutoMerge} from './SidebarDisableAutoMerge'
import {SidebarEnqueueButton} from './SidebarEnqueueButton'
import {SidebarMergeButton} from './SidebarMergeButton'

export function SidebarMergeWhenReadyButton() {
  const {validatedMergeData, mergeBoxPullRequest, status} = useSidebarMergeData()

  if (!validatedMergeData || !mergeBoxPullRequest) return null

  const {isInMergeQueue, mergeQueueEntry, autoMergeRequest, viewerMergeActions} = mergeBoxPullRequest
  const isMergeQueueEnabled =
    viewerMergeActions.find(action => action.name === MergeAction.MERGE_QUEUE)?.allowableStatus === 'ALLOWED'

  if (isInMergeQueue && mergeQueueEntry) return <SidebarQueuedState />
  if (autoMergeRequest) return <SidebarDisableAutoMerge />
  if (status === Status.Mergeable && isMergeQueueEnabled) return <SidebarEnqueueButton />
  // TODO: More mini buttons need to be added. Until then open the docked panel view
  if (status === Status.Mergeable) return <SidebarMergeButton />

  return null
}
